import { render, staticRenderFns } from "./EditReisen.vue?vue&type=template&id=6b781eb5&scoped=true"
import script from "./EditReisen.vue?vue&type=script&lang=ts"
export * from "./EditReisen.vue?vue&type=script&lang=ts"
import style0 from "./EditReisen.vue?vue&type=style&index=0&id=6b781eb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b781eb5",
  null
  
)

export default component.exports